import { Box, Text } from "@mantine/core";
import { memo, useMemo } from "react";

export const FormattedText = memo(
  ({ text, fontSize = 16 }: { text: string; fontSize?: number }) => {
    const lines = useMemo(() => {
      return text?.split("\n").map((lineText, lineIndex) => {
        if (!lineText) {
          return (
            <Box key={"empty_line_" + lineIndex} style={{ height: "1rem" }} />
          );
        }
        const spaces = [];
        for (let i = 0; i < lineText.length; i++) {
          if (lineText[i] === " ") {
            spaces.push(" ");
            continue;
          }
          break;
        }
        return (
          <Text
            key={lineText.length + "_" + lineIndex}
            style={{
              margin: 0,
              marginLeft: 4 * spaces.length,
              fontSize,
              overflowWrap: "break-word",
            }}
          >
            {lineText}
          </Text>
        );
      });
    }, [text, fontSize]);

    return <>{lines}</>;
  }
);
